<div class="container mx-auto mt-8">
  <h1 class="text-2xl mb-4">Oops - Seite nicht gefunden.</h1>
  <p>Diese Seite existiert nicht (mehr).</p>
  <p>
    <small>HTTP-404</small>
  </p>
</div>
